import { useEffect, useRef, useState } from "react";
import "./FadeInTel.css";

export default function ImageBeforeAfterSlider({ oldImage, newImage }) {
    const wrapRef = useRef(null);
    const boxRef = useRef(null);
    const overlayRef = useRef(null);
    const handleRef = useRef(null);
    const rangeRef = useRef(null);
    const [percent, setPercent] = useState(50);

    const applyByPercent = (p) => {
        if (!boxRef.current || !rangeRef.current || !wrapRef.current) return;

        const box = boxRef.current.getBoundingClientRect();
        const slider = rangeRef.current.getBoundingClientRect();

        // largeur réelle du pouce (valeur CSS var résolue)
        const thumbPx =
            parseFloat(getComputedStyle(wrapRef.current).getPropertyValue("--ba-thumb")) || 24;

        // longueur de piste exploitable = largeurSlider - largeurPouce
        const trackLen = Math.max(0, slider.width - thumbPx);

        // centre du pouce en px dans la page
        const thumbCenterX = slider.left + thumbPx / 2 + (p / 100) * trackLen;

        // position cible dans le conteneur image
        const px = Math.min(Math.max(thumbCenterX - box.left, 0), box.width);
        const cp = `inset(0 ${box.width - px}px 0 0)`;

        overlayRef.current.style.clipPath = cp;
        overlayRef.current.style.webkitClipPath = cp;
        handleRef.current.style.transform = `translateX(${px}px)`;
    };

    useEffect(() => { applyByPercent(percent); }, [percent]);

    useEffect(() => {
        const ro = new ResizeObserver(() => applyByPercent(percent));
        if (boxRef.current) ro.observe(boxRef.current);
        if (rangeRef.current) ro.observe(rangeRef.current);
        return () => ro.disconnect();
    }, [percent]);

    return (
        <div ref={wrapRef} className="ba-wrapper">
            <div ref={boxRef} className="ba-container">
                <img src={newImage} alt="" className="ba-image" />
                <div ref={overlayRef} className="ba-overlay">
                    <img src={oldImage} alt="" className="ba-image" />
                </div>
                <div ref={handleRef} className="ba-handle" />
            </div>

            <input
                ref={rangeRef}
                type="range"
                min="0"
                max="100"
                defaultValue={percent}
                onInput={(e) => applyByPercent(Number(e.target.value))}
                onChange={(e) => setPercent(Number(e.target.value))}
                className="ba-slider"
                aria-label="Comparateur avant/après"
            />
        </div>
    );
}
